import React from "react";
import styled from "@emotion/styled";
import { variablesSubstitution } from "./Variables";

const Logo = ({ ...props }) => (
  <Img
    src="data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAOUAAACqCAMAAAESHkgLAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSB
    JbWFnZVJlYWR5ccllPAAAADBQTFRFSEhI2NjYKioqt7e3x8fHZGRkmZmZ8/Pzp6eniIiIHR0deH
    h4/f395+fnGRkZ////wKc1hwAADSBJREFUeNq0kN0KwCAIhcVW6w97/7ddpbKtQQ3GvIhzPJD6Q
    ZkV9NclsSGISF5TpFZV0E0Ap7Gb/UyNippiFEM0imUK01TmPrbiuSVLj7tXAWsagQi7s/XKXBiB
    m9PguUZ3BhJGsvL2lYYffkZNTd+KpjTaIQwB9bTasO9o/JIeAogYWQYMxQhxmC8xGQywpMEHCwN
    kBiKc6SjLhZRyMNzMQFxowCIQgwEPDRZoqufjgeVBfiLczIXfR+iCPCh68YYzhAMsRdhhJQQnH3
    IexOujgUh1AAF4rdodBmEQ6HRqZFje/22NjvLR0WldMn4Cl8rdQfxevQRdmYBFKoMcgBwjZ9BAc
    YSkkTdVQlZWYhJo31toKvqiTFeD4ik0GSi0vaq310F3ph6ubzUcKR/MsIESlaxUMqrrwtOTE+Pl
    pbTyuWa8ZQn5luwAlMzMmWcxQUDT8fwHKRTT1G4J1RVu6+od0WYJgNPJqGYJLQzFFr69dPzehAx
    HyuJVXX+4Ev+FbgKwX25LDIIwEBUhRRHh//+2narAJnGqdqbtQ32MOV7ibhK7r5IzkcNzjshgxB
    L5PdvUrIR9s0YCkFUjPvLI+oWN2iCEBDNrjq11wW5CvULlGOlXMh4gveoYg+SjAhPmjcJrcSFJ2
    DQJUyZxrYXsL5JWTIsO80hMnlmt7axVaDjSjg58Fb0bPaXqWSHZTauGTIApm7edZ1uF2GD3muKL
    XbxQvN3rYuVJgfVgu+qUT/aEKEkcfiUSmtwZzN/xwuWsOruNtL8QbJByZ/NIKKRrp2HIfDGhyDV
    k3lcfklM7zbZbkErehLN7zAvCn8Pq7HC6J9BCjoIMr8jb+p5IEt8Ck4u8S+RCpou1tYLs+GKMpC
    saSumUhmBnPaPbPipeMczY4B6neeWAH39rT/iT+nEXgD2rXVIYhIGQCqU0tO//tjdqrQTy0apzM
    3cjv1cW0mQ3wTcav7/N6YEOidyqXDgPAqZqjKBonKEVvadd7gs6THfuMXeYKHBCD+1se+FXXdGe
    hziuG8+NYDPoaZFW2jFZxGDL6QEkzu1dgwt9/+0VyCNiO+eNUjpjbGZEecOgYihnBGi63A6MWd3
    Pmdd89IYPzgBKbLmp+SXMTDgnB1p0D+yXD2AS4USVMtDWWIkbnPie62ReUyuDZ27b16zqc5Y5D9
    QeWKpR1XClQ6OQRKHSmEEN7PPlTD050crCkIamP0nMbq3OO0mEkNF4bLrMybIVhpCRLBg/NCO9/
    hMnYfATh0AWwHHG6/fI7QsPWWW+FiLMRcFcbg/iLlr3TEsWSoDtANq83o8NWpYRTrZWaI6MbBnQ
    60ZZGltOJ0kCrnbBW6eqrX/XW1SMZbA1Zj9YMuW29mzFzEZbb5fV9nUgnOhVX1nY5OFSSfeyQu4
    5b5z5Dc/Gk54d7oz5N/sEr0V22y9YscVzsV1VzmL78ZZD3m5fqvpUQpu6v3zkbj+eqBVxdCDDww
    FNKGYrUWsf38BSD/UsxquC3KqZ0/U7j8z4aI1ljP5Nhpf5e366dE1EwR4vd2I3yJA13TA5lE/N2
    Zsbo2Hm+H1P+HL+F84fAdi3siRXYRgoFrMYOdz/tm8SQoKxpJaTfL0iv+OikQG5Fw1dkP81ZLcE
    ClMSexnvIvRvSehGo9Wuafhbs/QY0rAFX8B0inqE39GlHEzIUBxiXKqQaB5i956f3IfYiI7qR8B
    lKnqNpbEMKZ79lJc565ac4bJmxIbeZ1ySqRdBpXUwM1l3hlioUmN7hxoaQEFN7ltC6qyWMdeLry
    LTDQlA2pf2OuQuUTkgJWBz7RrLdsQs+paHYQ71t44WJGFSvithhyjNxZ+5lh3eqa1hhgzSlrjs0
    HVYEj139gSpYHYMq7yBHKIc7btD6js74wq2T5MqIAmb0rYnvYmitqZKsp7lgt7/JyRT5caCKMVO
    UrZXLNRsrFll8r2xbHpPdc9ya4qOy7HDK9ohOwckwcuB20qFxaZCTsAkPPTh4G14vA2NaZiOUyI
    61gzFeakaiRP0PfYi2SzzfF5uE27RPH71pxneRMTuFSdbWIF0pMcRmtX3dsJSYi1BjhlFNb5JOY
    TRAuunxUERROTyGXwO75OdcOVcu4vYT1pU2mMw2UYVCJxfUBYlTOCmChY+A+X1NLBucdD12vQso
    510w2k/rYvkhz6PvPjDgIx+GLQ5L0LfXYo/CObod3f/xcaqQd3xa3q00tCxvkjNDc+QqdV14yqJ
    gF5eM3viW4bRoNJbEgqVT0kl5aI8wimj2VBdhoxuZMgp4gZKNyS0ldbfSZCdTAoiMB4KTDSWQHD
    K4Xi9DkxNmMc4F6xAZ1uNY1JDfp3F7XqV0OGZFYtVEuQhr611CffeMSeDtr5U0cmCbNEQ2/tLiZ
    jrHoQ7Cm09AmGtCFBNRK8MgoIwe2Nt4T44ILleuEcgaTk5VHSogzSm5oJj0/par8Ce01sc9sQnV
    SLhDkyYh89e9Syjhdn8/o3d/nMBGGrff5e5cG+sWYq44qGRxQE5+ucaOsec4c6x/D12HdDAiO1d
    tQ7hXkw/3lTE3jH9yCs+SgpWkLQqWxggZNqqReMdB1I5RDSWoXp0rYP7TBLDWxCiVkM+UCe3jJl
    FHjuhq8ldtOC69rxdvryYvp9L1dNLbxfb/DqyoUl6xVNQUyhFtwR9ZIYqxkoOuzE/nmk7j7oYPE
    y55Nvwi2CY6/50Je4X5AV5QV6QF+R3v38CtHe1S5KrIFSNxkQx/f5vu/05bdKKgM7tO1Xx725TH
    CEoHHC+0aJ2ojxR/jmUbD6gUsSHYSj9FA+ZiFot9YWeN8d4awXMHm+4XYPdnPgblKkTftTpQ2mr
    hZwQIl1FmOsJuFqAanmoq7M91QE2yqXR13K1hiVATK4lZouegHNuqqMs15ZahY2ynMcNMNPEVAf
    cn3K02ljqAIby9Y/3d4Zo+m0KMUTc6Ashoq2hiympUxySTMrcMAaq4For8LLxVsXhkuKJcS1bPr
    /HZ9mSDDPYgkN4pnI3O5QOjJktJmholidezUYMlHd3OyiYwsZfhX4NJxDTaCJ/gsTn+Vq1yguBb
    6iaIbULeHx1PrvzjQzlYftElrzD9P2W3NViSyhvLYAvmEy5eoAJjrXKRSxm1+5wPEmUMcYYiS13
    oa1DuzzSgtmG7JY6mlK9PXYLMmNCjynfuwV9m5Ub8ziIubcl88v8ibKpR7ts5sH1iJmrKF2PLWO
    dZRB+4D0ukYfZA0r1sqURwIwUro2F0vSIiXVb9njs2ntYfnxQv2TLeWdLJszpMsQIqs6dSWO1Ou
    ZbOUgeSgOyXASxQY9PmNo9Fm7vDj3Dj2GfmPnlpyPI7i4/HUF2Qe4+Xhx+9vOEs1i7CaWNJX5fe
    sROyb7LQ0eq2GdXhKjm+KvHcxKdRVk6yp1UkDvb51TrAJCl/NILQB7TXxA6baH1Pgni9WEat1zd
    itwDszwXwNbP+HZbhEgdVam0cIzpqgXVWR535NvlPl/3qlUqk3qAbMMslyqBizMsaE2XjLOoTr3
    qDJGAEptzeYrRFAVVs07vY8dWKazW6yMK0szE2r/F76NKExkSHCiiTnNQJ61FW6jZXzgLJlcczn
    OWLOFxzonUITJ73i5rdNcV10WDiJt7KDnNDzFxntJFvDJ1Ju3bXJ/ibGQ/awmDJDE1/CIXDf/db
    9VfxPgbXPRLoE9JJw99WsLF+7eYDqhXdfRVDk1EG+U1OppP4ncCrpJpVhlL/uLKE3fTfCFYG2eh
    A6VfkQOz2h1b4B+VhEEep47CmPJ2rcARgE7ty4+Z2uYkEPdVdVRdN9pt3Uz49lMTCoXv10LMjoI
    lo4TbKCY98ZqqVmARtQjOmZvaUPJLzcyiTbEJBdhVkVj2Ws0q/oQC1asqSTSzWLCOSKILHK2wtL
    K2UaqfQiWjuFV4hKC/gifsTtg+BjZUAeQPg9ADU0qVTCNAHtVRx+tSlJJBbidJXhXXO4XETEnEe
    kSmfTWWg3MXauVESV757yhe75ziYEuvxDTJbj6rh0TOiiwQ5GIUwrhnJC0bph3RPLFTr4txr3Ne
    0cg9NovffYx7GsO4rwjjvo+wwvjTx9LaMSytI6Pc/i7K4HCPFZoyI/L7PFb/tsdOGUq2Laf/V/S
    pztJmfBcfpRlzzuU28B0niUFueHN4HyRMlHn1HgbdCjraJzDG/XFXl3yVbgiHfP+LjiO6Fh16Ww
    cjA3kkRpcBJrh/QsKPG/CcxCuJv+6lghjm/MmM94MsZtGu50KQpSX80BEKrwJInDZSKiKWZ8lQL
    imhjzKTvF6YqgZNqm5dbwechqZ1AIW8vTvzoW8s5eX0TcYdODEcZ6PJsyAvqrYym9enThUltBhk
    Mo1MUXBtMwgU5l7pMiGBMwj4dJUjMuXoyN6NKacyEQ11kpwNgrSW3mThT06WKPeAvgFZRlrasZY
    6ZGYPtJ2uyybP5w/z/5XucqwViMl/AE8xmsS99bO08LUf0+Wc098nyhPlifJEeaI8UZ4oT5Qnyh
    PlifKb6x9qNlxa0YcivQAAAABJRU5ErkJggg=="
    alt={variablesSubstitution(
      "Logo des Créateurs d'intérieur, collectif de décorateur et d'architecte d'intérieur rville"
    )}
  />
);

const Img = styled.img`
  float: left;
  margin-top: 5px;
  margin-right: 4px;
  width: 39px;
  height: 29px;

  @media (max-width: 600px) {
    width: 29px;
    height: 22px;
    margin-top: 9px;
  }
`;

export default Logo;
